<script setup lang="ts">
defineProps<{
  count: number;
}>();
</script>

<template>
  <div class="container mx-auto max-w-2xl px-4 py-4">
    <div
      v-for="i in count"
      :key="i"
      class="mb-4 flex items-start"
    >
      <div class="h-5 w-5 shrink-0 animate-pulse rounded-sm bg-gray-200" />

      <div class="ml-3 flex-1 space-y-1.5">
        <div class="h-3 w-full max-w-md animate-pulse rounded-sm bg-gray-200" />
        <div class="h-3 w-full max-w-lg animate-pulse rounded-sm bg-gray-200" />
        <div class="h-3 w-full max-w-xl animate-pulse rounded-sm bg-gray-200" />
      </div>
    </div>
  </div>
</template>
